import Api from "../ApiUtility/Api";

class DocketDetailsDS {
  constructor() {
    this.api = new Api();
  }

  // 📄 LIST Dockets
  WS_Data_Scrapper_Docker_Details_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Data_Scrapper_Docker_Details_GET")
      .then((data) => {
        console.log("WS_Data_Scrapper_Docker_Details_GET Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_Data_Scrapper_Docker_Details_GET API call:", error);
        throw error;
      });
  }

  // ➕ INSERT Docket
  WS_Data_Scrapper_Docker_Details_INSERT(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Data_Scrapper_Docker_Details_INSERT")
      .then((data) => {
        console.log("WS_Data_Scrapper_Docker_Details_INSERT Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_Data_Scrapper_Docker_Details_INSERT API call:", error);
        throw error;
      });
  }

  // 🔍 GET BY ID (optional but recommended)
  WS_Data_Scrapper_Docker_Details_GET_BY_ID(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Data_Scrapper_Docker_Details_GET_BY_ID")
      .then((data) => {
        console.log("WS_Data_Scrapper_Docker_Details_GET_BY_ID Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_Data_Scrapper_Docker_Details_GET_BY_ID API call:", error);
        throw error;
      });
  }

  // ✏️ UPDATE (future use)
  WS_Data_Scrapper_Docker_Details_UPDATE(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Data_Scrapper_Docker_Details_UPDATE")
      .then((data) => {
        console.log("WS_Data_Scrapper_Docker_Details_UPDATE Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_Data_Scrapper_Docker_Details_UPDATE API call:", error);
        throw error;
      });
  }

  WS_Docket_By_ID_GET(requestData) {
    return this.api
      .postAPI(requestData, "/dev/WS_Docket_By_ID_GET")
      .then((data) => {
        console.log("WS_Docket_By_ID_GET Response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error during WS_Docket_By_ID_GET API call:", error);
        throw error;
      });
  }
}

export default DocketDetailsDS;